module.exports = __webpack_public_path__ + "static/media/program-13.f3cb1deb.webp";